const deJSON = {
  // General
  Open: 'Öffnen',
  Close: 'Schließen',
  'Go to next page': 'Zur nächsten Seite',
  'Go to previous page': 'Zur vorherigen Seite',
  'Rows per page': 'Zeilen pro Seite',
  of: 'von',
  OR: 'ODER',
  'Something went wrong': 'Etwas ist schief gelaufen',
  // Status page
  "The page you were looking for doesn't exist.":
    'Die Seite, nach der Sie gesucht haben, existiert nicht.',
  "It's on us, we moved the content to a different page. The search below should help!":
    'Es liegt an uns, wir haben den Inhalt auf eine andere Seite verschoben. Die Suchfunktion unten sollte Ihnen helfen!',
  Search: 'Suchen',
  'Search terms here...': 'Suchbegriffe hier eingeben...',
  'Go to homepage': 'Zur Startseite',
  'You do not have permission to access this page':
    'Sie sind nicht berechtigt, diese Seite aufzurufen',
  'Please contact the Compair administrator to give you the appropriate permissions or sign in again with the correct account.':
    'Wenden Sie sich an den Compair-Administrator, um die erforderlichen Berechtigungen zu erhalten, oder melden Sie sich erneut mit dem richtigen Konto an.',
  'Return to homepage': 'Zurück zur Startseite',
  Unauthorized: 'Nicht berechtigt',
  // Homepage
  'Together we can achieve clean air for all':
    'Gemeinsam erzielen wir saubere Luft für alle',
  'Join COMPAIR and participate in measuring and reviewing air quality against other city data sources.':
    'Werden Sie Mitglied bei COMPAIR und beteiligen Sie sich an der Messung und Prüfung der Luftqualität im Abgleich mit anderen städtischen Datenquellen.',
  'Learn more': 'Erfahren Sie mehr',
  'What We Offer': 'Was wir anbieten',
  'Easy to understand Interactive Dashboards':
    'Verständlich gestaltete interaktive Dashboards',
  'A cool new way to visualise and explore potential (urban) solutions quickly and effectively':
    'Eine coole und neue Art, potenzielle (städtische) Lösungen schnell und effektiv zu visualisieren und zu erkunden',
  'Dynamic Exposure Visualisation Application':
    'Anwendung zur dynamischen Visualisierung der Luftbelastung',
  'Dynamic Exposure Visualisation':'Dynamische Visualisierung der Exposition',
  'Dynamic Exposure Visualisation Dashboard': 'Dynamische Expositionsvisualisierung Dashboard',
  'Learn how airborne pollutants, including fine dust, vary along routes taken by different modes of travel.': 'Erfahren Sie, wie Luftschadstoffe, einschließlich Feinstaub, entlang der Routen der verschiedenen verschiedenen Verkehrsträgern',
  'A better understanding of the local issues in order to be more collaborative and creative in coming up with solutions':
    'Eine bessere Wahrnehmung der lokalen Probleme, um bei der Entwicklung von Lösungen kooperativer und kreativer zu sein',
  'Try COMPAIR Tools': 'Probieren Sie die COMPAIR-Tools aus',
  'Making Data More Accessible, click through our offerings and try them for free.':
    'Machen Sie Daten zugänglicher, klicken Sie sich durch unsere Angebote und probieren Sie sie kostenlos aus.',
  'DEVA Application': 'DEVA-Anwendung',
  'Understand and compare how environmental situations change under different actions':
    'Verstehen und vergleichen Sie, wie sich die Umweltsituation durch verschiedene Maßnahmen verändert',
  'See how you can affect your carbon footprint through your daily activities and learn how you can reduce your carbon footprint':
    'Finden Sie heraus, wie Sie Ihren CO2-Fußabdruck durch Ihre täglichen Aktivitäten beeinflussen können, und erfahren Sie, wie Sie den CO2-Fußabdruck verringern können',
  'Explore your surroundings via your smartphone or tablet camera, so you can see a visual overlay of environmental information':
    'Erkunden Sie Ihre Umgebung mit der Kamera Ihres Smartphones oder Tablets, so dass Sie Umweltinformationen visuell überlagert sehen können',
  'Lets Be More Aware of Individual Actions and Behaviours':
    'Mehr Bewusstsein für individuelle Handlungen und Verhaltensweisen schaffen',
  'Use our dashboards and learn what needs to be done at a personal, local and city-wide level to improve air quality':
    'Nutzen Sie unsere Dashboards und erfahren Sie, was auf persönlicher, lokaler und städtischer Ebene getan werden muss, um die Luftqualität zu verbessern.',
  'Explore results via an easy app and generate ideas for change':
    'Erkunden Sie die Ergebnisse in einer einfachen App und entwickeln Sie Ideen für einen nachhaltigen Wandel',
  'Raise awareness about local issues in your community and take part in our experiments':
    'Steigern Sie das Bewusstsein für lokale Probleme in Ihrer Gemeinde und nehmen Sie an unseren Experimenten teil.',
  // Theme settings
  'Theme Settings': 'Thema Einstellungen',
  'Light mode': 'Heller Modus',
  'Pure Light': 'Reines Licht',
  'Dark mode': 'Dunkler Modus',
  'Dark Spaces': 'Dunkle Räume',
  // Navigation bar
  'Compair Dashboard': 'Compair Dashboard',
  Admin: 'Administrator',
  User: 'Benutzer',
  Guest: 'Gast',
  General: 'Allgemein',
  Home: 'Startseite',
  Dashboards: 'Dashboards',
  'Policy Monitoring': 'Monitoring der Auswirkungen der Politik',
  'Browse the map': 'Karte durchsuchen',
  'Carbon Footprint': 'CO2-Fußabdruck',
  Management: 'Verwaltung',
  'User Management': 'Benutzerverwaltung',
  // User management
  'All aspects related to the app users can be managed from this page':
    'Alle benutzerbezogenen Aspekte der App können auf dieser Seite verwaltet werden',
  'Create user': 'Nutzer erstellen',
  'Add new user': 'Neuen Nutzer hinzufügen',
  'Fill in the fields below to create and add a new user to the site':
    'Füllen Sie die folgenden Felder aus, um einen neuen Nutzer zu erstellen und zur Seite hinzuzufügen',
  'First name': 'Vorname',
  'The first name field is required': 'Vorname ist erforderlich',
  'Last name': 'Nachname',
  'The last name field is required': 'Nachname ist erforderlich',
  'Email address': 'E-Mail-Adresse',
  'The email field is required': 'E-Mail-Adresse ist erforderlich',
  'The email provided should be a valid email address':
    'Die angegebene E-Mail muss eine gültige E-Mail-Adresse sein.',
  Password: 'Kennwort',
  'The password field is required': 'Passwort ist erforderlich',
  'Must be at least 8 characters': 'Es muss mindestens 8 Zeichen lang sein',
  Administrator: 'Administrator',
  Cancel: 'Abbrechen',
  'All users': 'Alle Nutzer',
  Administrators: 'Administratoren',
  Users: 'Nutzer',
  'Search by name, email or username...':
    'Suche nach Name, E-Mail oder Benutzernamen...',
  Name: 'Name',
  Email: 'E-Mail',
  Role: 'Rolle',
  'Bulk actions': 'Massenaktionen',
  Delete: 'Löschen',
  'Are you sure you want to permanently delete this user account':
    'Sind Sie sicher, dass Sie dieses Nutzerkonto dauerhaft löschen möchten?',
  'The user account has been removed': 'Das Nutzerkonto wurde entfernt',
  'The user account was created successfully':
    'Das Nutzerkonto wurde erfolgreich erstellt',
  "We couldn't find any users matching your search criteria":
    'Wir konnten keine Nutzer finden, die Ihren Suchkriterien entsprechen',
  Edit: 'Bearbeiten',
  'Update user': 'Nutzer aktualisieren',
  'My Profile': 'Mein Profil',
  'Manage informations related to your profile settings':
    'Profileinstellungen verwalten',
  'Personal Details': 'Persönliche Daten',
  'Manage informations related to your personal details':
    'Persönlichen Daten verwalten',
  'Update profile': 'Profil aktualisieren',
  'Your profile was updated successfully':
    'Ihr Profil wurde erfolgreich aktualisiert',
  Security: 'Sicherheit',
  'Change your security preferences below':
    'Ändern Sie Ihre Sicherheitseinstellungen unten',
  'Change Password': 'Passwort ändern',
  'You can change your password here': 'Sie können Ihr Passwort hier ändern',
  'Change password': 'Passwort ändern',
  'Fill in the fields below to change your password':
    'Füllen Sie die folgenden Felder aus, um Ihr Passwort zu ändern',
  'Current password': 'Aktuelles Passwort',
  'New password': 'Neues Kennwort',
  'New password is required': 'Neues Passwort ist erforderlich',
  'Confirm new password': 'Bestätigen Sie das neue Passwort',
  'Confirm password is required': 'Bestätigung des Passworts ist erforderlich',
  'Current password is required': 'Aktuelles Passwort ist erforderlich',
  'New password must be at least 8 characters':
    'Neues Passwort muss mindestens 8 Zeichen lang sein',
  'Passwords do not match': 'Passwörter stimmen nicht überein',
  'Update password': 'Passwort aktualisieren',
  // Top navigation bar
  'My profile': 'Mein Profil',
  'Log in to view your details': 'Loggen Sie sich ein, um Ihre Daten zu sehen',
  'Language Switcher': 'Sprache wechseln',
  // Authentication
  'Sign out': 'Abmelden',
  'Sign in': 'Anmelden',
  'Fill in the fields below to sign into your account.':
    'Füllen Sie die folgenden Felder aus, um sich bei Ihrem Konto anzumelden.',
  'Lost password?': 'Passwort vergessen?',
  'Username or password is incorrect': 'Benutzername oder Passwort ist falsch',
  'Don’t have an account, yet?': 'Sie haben noch kein Konto?',
  'Sign up here': 'Registrieren Sie sich hier',
  'Recover Password': 'Passwort wiederherstellen',
  'Enter the email used for registration to reset your password.':
    'Geben Sie die E-Mail-Adresse ein, mit der Sie sich registriert haben, um Ihr Passwort zurückzusetzen.',
  'Send me a new password': 'Neues Passwort zusenden',
  'Want to try to sign in again?': 'Möchten Sie sich erneut anmelden?',
  'Click here': 'Klicken Sie hier',
  'Create account': 'Konto erstellen',
  'Fill in the fields below to sign up for an account.':
    'Füllen Sie die unten stehenden Felder aus, um ein Konto zu erstellen.',
  'Password must be at least 8 characters':
    'Das Passwort muss mindestens 8 Zeichen lang sein.',
  'Both password need to be the same': 'Beide Passwörter müssen identisch sein',
  'You must agree to our terms and conditions':
    'Sie müssen unseren Allgemeinen Geschäftsbedingungen zustimmen',
  'Create your account': 'Erstellen Sie Ihr Konto',
  'Already have an account?': 'Sie haben bereits ein Konto?',
  'Sign in here': 'Hier anmelden',
  'You have successfully signed up to Compair. Sign in below to continue':
    'Sie haben sich erfolgreich bei Compair angemeldet. Melden Sie sich unten an, um fortzufahren',
  'Confirm password': 'Bestätigen Sie Ihr Passwort',
  'I accept the': 'Ich akzeptiere die',
  'terms and conditions': 'Geschäftsbedingungen',
  // Footer
  'by COMPAIR Project': 'vom COMPAIR-Projekt',
  "This project has received funding from the European Union's Horizon 2020 research and innovation programme under grant agreement No 101036563. This website represents the views of the COMPAIR project only.":
    'Dieses Projekt wurde durch das Forschungs- und Innovationsprogramm Horizont 2020 der Europäischen Union unter der Fördervereinbarung Nr. 101036563 gefördert. Diese Website gibt ausschließlich die Ansichten des COMPAIR-Projekts wieder.',
  'Terms & Conditions': 'Geschäftsbedingungen',
  'Privacy Policy': 'Datenschutzbestimmungen',
};

export default deJSON;
